import { CardActions, CardContent, CardHeader, CardMedia, IconButton, List, ListItem, Paper, Typography, useTheme } from '@mui/material';
import moment from 'moment';
import route from '../../Router';
import DataListView, { getId } from '../../components/data/DataListView';
import { BaseDataTable, ColumnData, DataTableProps } from '../../components/data/DataTable';
import DataView from '../../components/data/DataView';
import { ViewMode } from '../../components/data/ViewModes';
import { hasKey, isOwner } from '../../models/Identity';
import { Post } from '../../models/Types';
import { getTheme } from '../../theme';
import { isMobile } from '../../utils';
import { PostCard } from './PostCard';
import { PostForm, postParse } from './PostForm';
import { EditOutlined, VisibilityOutlined } from '@mui/icons-material';
import { NavIconButton } from '../../components/NavLink';
import { root } from '../../models/Proxy';

const columns: ColumnData<Post>[] = [{
    label: 'Заголовок',
    name: 'Name',
    filter: true,
    routerLink: true
}, {
    label: 'Тэги',
    name: 'HashTags',
    type: 'array',
    filter: true,
    renderer: (val, obj) => (val as string[])?.join(', ')
}, {
    label: 'Дата публикации',
    name: 'CreateDate',
    type: 'date',
    filter: true
}];

class PostTable extends BaseDataTable<Post>{

    public getData() {
        return super.getData()?.sort((a, b) => b.CreateDate.getTime() - a.CreateDate.getTime());
    }

    renderTable() {
        return <List sx={{ m: 0, px: 1 }}>
            {this.getData().map((row, i) => <ListItem key={i}
                component={Paper}
                elevation={0}
                sx={{
                    cursor: 'pointer',
                    borderWidth: 1,
                    overflow: 'hidden',
                    borderStyle: 'solid',
                    my: 1,
                    borderColor: getTheme().palette.divider
                }}
                data-route={'hideForm=&id=' + row.Id}>
                <CardMedia style={row?.StoryImage ? { backgroundImage: `url(${root}files/${row.StoryImage})` } : undefined} sx={{
                    width: 75,
                    height: 75,
                    ml: -2,
                    my: -1
                }} />
                <CardHeader title={row.Name} titleTypographyProps={{ variant: isMobile() ? 'h2' : 'h2' }} sx={{flex:1}} />
                <CardContent>
                    <Typography variant="caption">{moment(row.CreateDate).calendar()}</Typography>
                </CardContent>
                <CardActions disableSpacing>
                    <NavIconButton size="small" route={[['id', row.Id], ['hideForm'], ['edit', true]]}><EditOutlined fontSize="small" color="primary" /></NavIconButton>
                </CardActions>
            </ListItem>)}
        </List>;
    }
}

function ThemedTable(props: DataTableProps<Post>) {
    const theme = useTheme();
    return <PostTable {...props} theme={theme} />;
}

export class PostListView extends DataListView<Post>{
    protected renderTable(props: DataTableProps<Post>, mode?: ViewMode<Post>) {
        return <ThemedTable {...props} />;
    }

    buildAddButton(newTitleText: React.ReactNode, props?: any) {
        return super.buildAddButton('Опубликовать', props);
    }

    buildBody() {
        return <>
            {this.buildTopToolbar()}

            {this.buildView()}
        </>;
    }

    render() {
        if (getId(this.props) >= 0 && !route.get('hideForm')) {
            return <></>;
        } else {
            return super.render();
        }
    }
}

export default function PostView() {
    return <DataView<Post>
        title="Новость"
        titleMultiple="Новости"
        typeId="Post"
        modes={[{ mode: 'list', hideAddBtn: !hasKey('Post') }]}
        form={(id, apiRef) => <PostCard key="main" id={id} apiRef={apiRef} />}
        editForm={(id, apiRef) => <PostForm key="main" id={id} apiRef={apiRef} />}
        canEdit={isOwner()}
        listView={(props, setListApi) => <PostListView {...props} apiRef={setListApi} /> }
        tableProps={{ columns, dataParser: postParse }} />;
}